<!-- Header -->
<div class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel">
      <input type="text" name="search" class="form-control" placeholder="Search"
        [(ngModel)]="pncQueryParam.query" style="border-color:#CFD7E6;font-weight:200;"
        (ngModelChange)="getPncReportList()">
      <button type="button" class="btn btn-bvq pull-right ml-2" (click)="createPncReport(null)">Create PNC Report</button>
    </div>
  </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- List of PNC report -->
<div class="container" [hidden]="loading">
  <!-- No PNC found message -->
  <div class="no-items" *ngIf="pncList?.length == 0">
    No PNC Reports has been found
  </div>

  <!-- PNC Header -->
  <div class="pnc-header" *ngIf="pncList?.length > 0">
    <div class="item">
      <div class="row">
        <div class="col-md-12">
          <span (click)="sortPnc('DATE')">
            Issue Month
            <i class="fa {{pncQueryParam.field === 'DATE' ? pncQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- PNc List -->
  <div class="pnc-list" *ngIf="pncList?.length > 0">
    <div class="pnc">
      <div *ngFor="let pnc of pncList; let i = index;">
        <div class="item">
          <div class="row">
            <!-- Pnc Date -->
            <div class="column col-md-11 pointer" (click)="createPncReport(pnc)">
              <div>National Economic Outlook - {{pnc.DATE}}</div>
            </div>

            <!-- PNC options -->
            <div class="column end col-md-1 action">
              <div class="btn-group" dropdown>
                <button dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle sub"
                  placement="bottom right">
                  <i class="fa fa-ellipsis-v"></i>
                </button>

                <div *dropdownMenu class="drop-menu">
                  <a class="drop-item" (click)="removePnc(pnc)">
                    <div class="item" style="display: contents;">Delete</div>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PNC Pagination -->
  <div class="pagination-wrapper pagination-cls" [hidden]="loading || totalItems < 25">
    <pagination [boundaryLinks]="true" [totalItems]="totalItems" [itemsPerPage]="25" [maxSize]="5"
      (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>
